      <!-- VISUALIZE DISPLAY OF EVENT -->
      <div *ngIf="!loading">
        <div class="header">
          <div>
            <mat-icon class="icon"  (click)="edit()">
              edit
            </mat-icon>
          </div>
          <mat-icon class="icon" (click)="close()">
            close
          </mat-icon>
        </div>
        <div *ngIf="state === 'view'">
          <h2>{{ event.fullName }}</h2>
          <p>Descripción: {{ event.description }}</p>
          <div>
            <p>
              Categorías: 
            </p>
            <mat-chip-list>
              <mat-chip *ngFor="let category of event.categories">
                {{ getCategoryName(category) }}
              </mat-chip>
            </mat-chip-list>
          </div>
          <p>Id: {{ event.eventId }}</p>
          <p>Inicio: {{ event.startDateOfEvent.seconds * 1000 |  date:'shortDate':'es' }}</p>
          <p>Culminación: {{ event.dueDateOfEvent.seconds * 1000 | date:'shortDate':'es' }}</p>
          <p>Fecha de creación : {{ event.createdAt.seconds * 1000 |  date:'shortDate':'es' }}</p>
          <p>Reservas habilitadas: {{ event.availableReservation | boolean }}</p>
          <p>Promoción: {{ event?.isOffer | boolean }}</p>
          <p>Link de google maps : {{ event.locationName }}</p>
          <p>Conteo de "me gusta": {{ event.likes }}</p>
          <p>Precio: {{ event.priceRange | formattedPrice}}</p>
          <!-- <p>Reservation Count: {{ event.reservationsCount }}</p> -->
          <p>Clicks: {{ event.clicks }}</p>
          <p>Guardados: {{ event.saved }}</p>
          <p>Retroalimentación: {{ event.feedback }}</p>
          <p>Compartido: {{ event.shared }}</p>
          <p>Wahtsapp alcance: {{ event.wantToReserve }}</p>
          <img [src]="imageUrl" alt="event image">
        </div>

        <div *ngIf="state === 'edit'">
          <app-event-form
          [selectedEvent]="event"
          [state]="state"
          [imageUrl]="imageUrl"
          (saved)="closeDialog()"
          >

          </app-event-form>
        </div>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner color="accent" diameter="40"></mat-spinner>
    </div>